import classNames from 'classnames'
import Icon from '@components/Icon'
import CircleLoader from '@components/CircleLoader'
import './textfield.scss'

export default function Textfield({
    label,
    iconLeft,
    iconRight,
    isLoading,
    status,
    size,
    className,
    initialValue,
    ...inputProps
}) {
    const [value, setValue] = React.useState(initialValue || inputProps.value || '')
    const getIconSize = () => (size === 'small' ? 'xs' : 'sm')

    const onInputChange = e => {
        const value = e.target.value
        setValue(value)
        inputProps.onChange && inputProps.onChange(e, value)
    }

    const classList = classNames('textfield', {
        'is-active': value,
        'is-loading': isLoading,
        [`textfield--${size}`]: size,
        'textfield--icon-left': iconLeft,
        'textfield--icon-right': iconRight,
        'textfield--no-label': !label,
        [`textfield--${status}`]: status,
        [`${className}`]: className,
    })

    return (
        <div className={classList}>
            {iconLeft && (
                <Icon type={iconLeft} size={getIconSize()} className="textfield__icon textfield__icon--left" />
            )}
            <input
                {...inputProps}
                value={inputProps.value !== undefined ? inputProps.value : value}
                className="textfield__input"
                onChange={onInputChange}
            />
            <label className="textfield__label">{label}</label>
            {isLoading ? (
                <div className="textfield__loader">
                    <CircleLoader size="small" />
                </div>
            ) : iconRight ? (
                <Icon type={iconRight} size={getIconSize()} className="textfield__icon textfield__icon--right" />
            ) : null}
        </div>
    )
}

Textfield.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    success: PropTypes.bool,
    iconLeft: PropTypes.string,
    iconRight: PropTypes.string,
    size: PropTypes.oneOf(['small']),
    status: PropTypes.oneOf(['success']),
}
